<template>
	<div :class="`fixed-screen background-${accent}`" />
</template>

<script>
	export default {
        computed: {
            accent() {
                return this.$store.state.backgroundAccent;
            }
        }
	}
</script>

<style lang="less" scoped>
	@import "~@less/variables.less";

    .gradient-bg(@col) {
        background: linear-gradient(225deg, tint(@col, 20%) 0%, shade(@col, 10%) 100%);
    }

    .fixed-screen {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .background {
        &-primary {
            .gradient-bg(@teal)          
        }

        &-secondary {
            .gradient-bg(@tomato)          
        }

        &-white {
            .gradient-bg(@whiteish)          
        }
    }
</style>